import ky, { isHTTPError } from 'ky';
import type { HttpErroBody, ValidatorError } from './model';

const API_PREFIX = '/api/v2';

export const http = ky.extend({
  prefix: `${API_PREFIX}`,
  retry: 0,
  timeout: import.meta.env.DEV ? false : 120_000,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        const locks = navigator.locks as Navigator['locks'] | undefined;

        const access_token =
          locks && !request.url.endsWith('/oauth2/refresh')
            ? await locks.request('access_token', { mode: 'shared' }, () =>
                localStorage.getItem('access_token'),
              )
            : localStorage.getItem('access_token');

        if (access_token) {
          request.headers.set('Authorization', `Bearer ${access_token}`);
        }
      },
    ],
    beforeError: [
      async ({ error }) => {
        if (isHTTPError(error)) {
          const { response } = error;

          if (response.status >= 500) {
            const data = error.data as HttpErroBody<string>;

            if ('detail' in Object(data)) {
              error.message = data.detail;
            }

            return error;
          }

          if (response.status === 422) {
            const validatorError = error.data as HttpErroBody<ValidatorError[]>;

            try {
              const firstError = validatorError.detail.at(0);
              error.message = `请求参数错误：${firstError?.loc.join('.')} - ${validatorError.detail.at(0)?.msg}`;
            } catch {
              error.message = `请求参数错误：${JSON.stringify(validatorError)}`;
            }
          } else if (
            typeof error.data === 'object' &&
            error.data != null &&
            'detail' in error.data
          ) {
            const commonError = error.data as HttpErroBody<string>;
            error.message = commonError.detail;
          }
        }

        return error;
      },
    ],
  },
});
